<template>
  <h1
    class="font-weight-light font-miller-display decorated pb-4"
    :class="headingSize"
    v-html="text"
  ></h1>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },

  computed: {
    headingSize() {
      if (this.$vuetify.breakpoint.md) return "display-1";
      if (this.$vuetify.breakpoint.smAndDown) return "title";
      return "display-2";
    },
  },
};
</script>